module.exports = __webpack_public_path__ + "img/emptyStar.28a72bd5.svg";